<template>
<div class="dboard-card">
  <div class="row row-space-nextline">
    <div class="col-lg-6 border">
      <div class="dboard-card-title">
        Total Indents
      </div>
      <div class="dboard-card-panel">
        <div class="dboard-card-panel-section">
          <div class="dboard-card-section-primarynumber primary-text">
            {{activeIntends + count.delivered + count.delivery_pending}}
          </div>
          <!-- <div class="dboard-info">
            <div class="col-div arrow-style">
            <svgicon name="up-arrow-success" class="icon" width="12" height="12" :original="true" />
          </div>
          <div class="col-div">
            <div class="count-primary-text">8.5%</div>
          </div>
          <div class="col-div info">
            <div class="info-text">From last month</div>
          </div>
          </div> -->
        </div>
      </div>
    </div>
    <div class="col-lg-6 border">
      <div class="dboard-card-title">
        Total SLA Breach
      </div>
      <div class="dboard-card-panel">
        <div class="dboard-card-panel-section">
          <div class="dboard-card-section-primarynumber tertiary-text">
            {{count.delivered - sladata.sla.delivered}}
          </div>
          <div class="dboard-info">
            <!-- <div class="col-div arrow-style">
            <svgicon name="up-arrow-error" class="icon" width="12" height="12" :original="true" />
          </div> -->
          <!-- <div class="col-div">
            <div class="count-sec-text">3 %</div>
          </div>
          <div class="col-div info">
            <div class="info-text">From last month</div>
          </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  props: {
    isLoading: {
      type: Boolean,
    },
    count: {
      type: Object,
    },
    activeIntends: {
      type: Number,
    },
    sladata: {
      type: Object,
    },
  },
};
</script>
